/**
 * @generated SignedSource<<ac0c994d32734d279125a403dce13a2b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RecordingControls_viewer$data = {
  readonly hasAccessToCopilot: boolean;
  readonly " $fragmentSpreads": FragmentRefs<"StartAndAutoRecordingControls_viewer">;
  readonly " $fragmentType": "RecordingControls_viewer";
};
export type RecordingControls_viewer$key = {
  readonly " $data"?: RecordingControls_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"RecordingControls_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RecordingControls_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasAccessToCopilot",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "StartAndAutoRecordingControls_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "58c1d944685649fbbaabaa59e2b2da20";

export default node;
